import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CrazyCallConfigService } from './services/crazycall-config.service';

@Injectable({
  providedIn: 'root'
})
export class LeadGenerationCodeService {
  constructor(private crazyCallConfigService: CrazyCallConfigService) {}

  public htmlCodeToInstall(): string {
    // noinspection CheckTagEmptyBody,JSUnresolvedLibraryURL
    return `<script>
  window.ChannelsSettings = {
    appId: "${this.crazyCallConfigService.appId}"
  };
</script>
<script defer src="${environment.WEB_CALL_SCRIPT_URL}"></script>
    `;
  }
}
